var ie = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, O = "1.9.0", D = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function ae(e) {
  var t = /* @__PURE__ */ new Set([e]), r = /* @__PURE__ */ new Set(), i = e.match(D);
  if (!i)
    return function() {
      return !1;
    };
  var a = {
    major: +i[1],
    minor: +i[2],
    patch: +i[3],
    prerelease: i[4]
  };
  if (a.prerelease != null)
    return function(c) {
      return c === e;
    };
  function n(s) {
    return r.add(s), !1;
  }
  function o(s) {
    return t.add(s), !0;
  }
  return function(c) {
    if (t.has(c))
      return !0;
    if (r.has(c))
      return !1;
    var u = c.match(D);
    if (!u)
      return n(c);
    var f = {
      major: +u[1],
      minor: +u[2],
      patch: +u[3],
      prerelease: u[4]
    };
    return f.prerelease != null || a.major !== f.major ? n(c) : a.major === 0 ? a.minor === f.minor && a.patch <= f.patch ? o(c) : n(c) : a.minor <= f.minor ? o(c) : n(c);
  };
}
var ue = ae(O), oe = O.split(".")[0], y = Symbol.for("opentelemetry.js.api." + oe), L = ie;
function j(e, t, r, i) {
  var a;
  i === void 0 && (i = !1);
  var n = L[y] = (a = L[y]) !== null && a !== void 0 ? a : {
    version: O
  };
  if (!i && n[e]) {
    var o = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
    return r.error(o.stack || o.message), !1;
  }
  if (n.version !== O) {
    var o = new Error("@opentelemetry/api: Registration of version v" + n.version + " for " + e + " does not match previously registered API v" + O);
    return r.error(o.stack || o.message), !1;
  }
  return n[e] = t, r.debug("@opentelemetry/api: Registered a global for " + e + " v" + O + "."), !0;
}
function v(e) {
  var t, r, i = (t = L[y]) === null || t === void 0 ? void 0 : t.version;
  if (!(!i || !ue(i)))
    return (r = L[y]) === null || r === void 0 ? void 0 : r[e];
}
function K(e, t) {
  t.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + O + ".");
  var r = L[y];
  r && delete r[e];
}
var se = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var i = r.call(e), a, n = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = i.next()).done; ) n.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (r = i.return) && r.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return n;
}, fe = function(e, t, r) {
  if (r || arguments.length === 2) for (var i = 0, a = t.length, n; i < a; i++)
    (n || !(i in t)) && (n || (n = Array.prototype.slice.call(t, 0, i)), n[i] = t[i]);
  return e.concat(n || Array.prototype.slice.call(t));
}, ce = (
  /** @class */
  function() {
    function e(t) {
      this._namespace = t.namespace || "DiagComponentLogger";
    }
    return e.prototype.debug = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return p("debug", this._namespace, t);
    }, e.prototype.error = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return p("error", this._namespace, t);
    }, e.prototype.info = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return p("info", this._namespace, t);
    }, e.prototype.warn = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return p("warn", this._namespace, t);
    }, e.prototype.verbose = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return p("verbose", this._namespace, t);
    }, e;
  }()
);
function p(e, t, r) {
  var i = v("diag");
  if (i)
    return r.unshift(t), i[e].apply(i, fe([], se(r), !1));
}
var E;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(E || (E = {}));
function _e(e, t) {
  e < E.NONE ? e = E.NONE : e > E.ALL && (e = E.ALL), t = t || {};
  function r(i, a) {
    var n = t[i];
    return typeof n == "function" && e >= a ? n.bind(t) : function() {
    };
  }
  return {
    error: r("error", E.ERROR),
    warn: r("warn", E.WARN),
    info: r("info", E.INFO),
    debug: r("debug", E.DEBUG),
    verbose: r("verbose", E.VERBOSE)
  };
}
var Ee = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var i = r.call(e), a, n = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = i.next()).done; ) n.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (r = i.return) && r.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return n;
}, le = function(e, t, r) {
  if (r || arguments.length === 2) for (var i = 0, a = t.length, n; i < a; i++)
    (n || !(i in t)) && (n || (n = Array.prototype.slice.call(t, 0, i)), n[i] = t[i]);
  return e.concat(n || Array.prototype.slice.call(t));
}, Te = "diag", m = (
  /** @class */
  function() {
    function e() {
      function t(a) {
        return function() {
          for (var n = [], o = 0; o < arguments.length; o++)
            n[o] = arguments[o];
          var s = v("diag");
          if (s)
            return s[a].apply(s, le([], Ee(n), !1));
        };
      }
      var r = this, i = function(a, n) {
        var o, s, c;
        if (n === void 0 && (n = { logLevel: E.INFO }), a === r) {
          var u = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return r.error((o = u.stack) !== null && o !== void 0 ? o : u.message), !1;
        }
        typeof n == "number" && (n = {
          logLevel: n
        });
        var f = v("diag"), _ = _e((s = n.logLevel) !== null && s !== void 0 ? s : E.INFO, a);
        if (f && !n.suppressOverrideMessage) {
          var x = (c = new Error().stack) !== null && c !== void 0 ? c : "<failed to generate stacktrace>";
          f.warn("Current logger will be overwritten from " + x), _.warn("Current logger will overwrite one already registered from " + x);
        }
        return j("diag", _, r, !0);
      };
      r.setLogger = i, r.disable = function() {
        K(Te, r);
      }, r.createComponentLogger = function(a) {
        return new ce(a);
      }, r.verbose = t("verbose"), r.debug = t("debug"), r.info = t("info"), r.warn = t("warn"), r.error = t("error");
    }
    return e.instance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e;
  }()
);
function de(e) {
  return Symbol.for(e);
}
var Oe = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r = this;
      r._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), r.getValue = function(i) {
        return r._currentContext.get(i);
      }, r.setValue = function(i, a) {
        var n = new e(r._currentContext);
        return n._currentContext.set(i, a), n;
      }, r.deleteValue = function(i) {
        var a = new e(r._currentContext);
        return a._currentContext.delete(i), a;
      };
    }
    return e;
  }()
), Re = new Oe(), he = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var i = r.call(e), a, n = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = i.next()).done; ) n.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (r = i.return) && r.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return n;
}, pe = function(e, t, r) {
  if (r || arguments.length === 2) for (var i = 0, a = t.length, n; i < a; i++)
    (n || !(i in t)) && (n || (n = Array.prototype.slice.call(t, 0, i)), n[i] = t[i]);
  return e.concat(n || Array.prototype.slice.call(t));
}, ye = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.active = function() {
      return Re;
    }, e.prototype.with = function(t, r, i) {
      for (var a = [], n = 3; n < arguments.length; n++)
        a[n - 3] = arguments[n];
      return r.call.apply(r, pe([i], he(a), !1));
    }, e.prototype.bind = function(t, r) {
      return r;
    }, e.prototype.enable = function() {
      return this;
    }, e.prototype.disable = function() {
      return this;
    }, e;
  }()
), Le = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var i = r.call(e), a, n = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = i.next()).done; ) n.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (r = i.return) && r.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return n;
}, ve = function(e, t, r) {
  if (r || arguments.length === 2) for (var i = 0, a = t.length, n; i < a; i++)
    (n || !(i in t)) && (n || (n = Array.prototype.slice.call(t, 0, i)), n[i] = t[i]);
  return e.concat(n || Array.prototype.slice.call(t));
}, S = "context", Ae = new ye(), ge = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalContextManager = function(t) {
      return j(S, t, m.instance());
    }, e.prototype.active = function() {
      return this._getContextManager().active();
    }, e.prototype.with = function(t, r, i) {
      for (var a, n = [], o = 3; o < arguments.length; o++)
        n[o - 3] = arguments[o];
      return (a = this._getContextManager()).with.apply(a, ve([t, r, i], Le(n), !1));
    }, e.prototype.bind = function(t, r) {
      return this._getContextManager().bind(t, r);
    }, e.prototype._getContextManager = function() {
      return v(S) || Ae;
    }, e.prototype.disable = function() {
      this._getContextManager().disable(), K(S, m.instance());
    }, e;
  }()
), X = ge.getInstance(), d = m.instance(), Se = "process.runtime.name", Ie = "service.name", Pe = "telemetry.sdk.name", be = "telemetry.sdk.language", me = "telemetry.sdk.version", Ne = Se, we = Ie, N = Pe, w = be, C = me, Ce = "webjs", Me = Ce, Ue = "server.address", Be = "service.name", xe = "service.version", Y = de("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function De(e) {
  return e.setValue(Y, !0);
}
function on(e) {
  return e.getValue(Y) === !0;
}
function Xe() {
  return function(e) {
    d.error(Ge(e));
  };
}
function Ge(e) {
  return typeof e == "string" ? e : JSON.stringify(He(e));
}
function He(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(i) {
      if (!t[i]) {
        var a = r[i];
        a && (t[i] = String(a));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var Ve = Xe();
function sn(e) {
  try {
    Ve(e);
  } catch {
  }
}
var M;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(M || (M = {}));
var Fe = ",", je = ["OTEL_SDK_DISABLED"];
function Ke(e) {
  return je.indexOf(e) > -1;
}
var Ye = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function $e(e) {
  return Ye.indexOf(e) > -1;
}
var ke = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function Je(e) {
  return ke.indexOf(e) > -1;
}
var I = 1 / 0, P = 128, Qe = 128, We = 128, $ = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: E.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: I,
  OTEL_ATTRIBUTE_COUNT_LIMIT: P,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: I,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: P,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: I,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: P,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: Qe,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: We,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: M.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function qe(e, t, r) {
  if (!(typeof r[e] > "u")) {
    var i = String(r[e]);
    t[e] = i.toLowerCase() === "true";
  }
}
function ze(e, t, r, i, a) {
  if (i === void 0 && (i = -1 / 0), a === void 0 && (a = 1 / 0), typeof r[e] < "u") {
    var n = Number(r[e]);
    isNaN(n) || (n < i ? t[e] = i : n > a ? t[e] = a : t[e] = n);
  }
}
function Ze(e, t, r, i) {
  i === void 0 && (i = Fe);
  var a = r[e];
  typeof a == "string" && (t[e] = a.split(i).map(function(n) {
    return n.trim();
  }));
}
var er = {
  ALL: E.ALL,
  VERBOSE: E.VERBOSE,
  DEBUG: E.DEBUG,
  INFO: E.INFO,
  WARN: E.WARN,
  ERROR: E.ERROR,
  NONE: E.NONE
};
function rr(e, t, r) {
  var i = r[e];
  if (typeof i == "string") {
    var a = er[i.toUpperCase()];
    a != null && (t[e] = a);
  }
}
function k(e) {
  var t = {};
  for (var r in $) {
    var i = r;
    switch (i) {
      case "OTEL_LOG_LEVEL":
        rr(i, t, e);
        break;
      default:
        if (Ke(i))
          qe(i, t, e);
        else if ($e(i))
          ze(i, t, e);
        else if (Je(i))
          Ze(i, t, e);
        else {
          var a = e[i];
          typeof a < "u" && a !== null && (t[i] = String(a));
        }
    }
  }
  return t;
}
var J = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function fn() {
  var e = k(J);
  return Object.assign({}, $, e);
}
function cn() {
  return k(J);
}
function G(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function B(e) {
  for (var t = new Uint8Array(e.length / 2), r = 0, i = 0; i < e.length; i += 2) {
    var a = G(e.charCodeAt(i)), n = G(e.charCodeAt(i + 1));
    t[r++] = a << 4 | n;
  }
  return t;
}
var U = performance, nr = "1.30.1", h, b = (h = {}, h[N] = "opentelemetry", h[Ne] = "browser", h[w] = Me, h[C] = nr, h);
function _n(e) {
}
var tr = 9, ir = 6, ar = Math.pow(10, ir), A = Math.pow(10, tr);
function g(e) {
  var t = e / 1e3, r = Math.trunc(t), i = Math.round(e % 1e3 * ar);
  return [r, i];
}
function Q() {
  var e = U.timeOrigin;
  if (typeof e != "number") {
    var t = U;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function ur(e) {
  var t = g(Q()), r = g(typeof e == "number" ? e : U.now());
  return sr(t, r);
}
function En(e) {
  if (W(e))
    return e;
  if (typeof e == "number")
    return e < Q() ? ur(e) : g(e);
  if (e instanceof Date)
    return g(e.getTime());
  throw TypeError("Invalid input type");
}
function ln(e, t) {
  var r = t[0] - e[0], i = t[1] - e[1];
  return i < 0 && (r -= 1, i += A), [r, i];
}
function or(e) {
  return e[0] * A + e[1];
}
function Tn(e) {
  return e[0] * 1e6 + e[1] / 1e3;
}
function W(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function dn(e) {
  return W(e) || typeof e == "number" || e instanceof Date;
}
function sr(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= A && (r[1] -= A, r[0] += 1), r;
}
var l;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(l || (l = {}));
function fr(e, t) {
  return new Promise(function(r) {
    X.with(De(X.active()), function() {
      e.export(t, function(i) {
        r(i);
      });
    });
  });
}
var On = {
  _export: fr
};
function cr() {
  return "unknown_service";
}
var T = function() {
  return T = Object.assign || function(e) {
    for (var t, r = 1, i = arguments.length; r < i; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, T.apply(this, arguments);
}, _r = function(e, t, r, i) {
  function a(n) {
    return n instanceof r ? n : new r(function(o) {
      o(n);
    });
  }
  return new (r || (r = Promise))(function(n, o) {
    function s(f) {
      try {
        u(i.next(f));
      } catch (_) {
        o(_);
      }
    }
    function c(f) {
      try {
        u(i.throw(f));
      } catch (_) {
        o(_);
      }
    }
    function u(f) {
      f.done ? n(f.value) : a(f.value).then(s, c);
    }
    u((i = i.apply(e, t || [])).next());
  });
}, Er = function(e, t) {
  var r = { label: 0, sent: function() {
    if (n[0] & 1) throw n[1];
    return n[1];
  }, trys: [], ops: [] }, i, a, n, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(u) {
    return function(f) {
      return c([u, f]);
    };
  }
  function c(u) {
    if (i) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (i = 1, a && (n = u[0] & 2 ? a.return : u[0] ? a.throw || ((n = a.return) && n.call(a), 0) : a.next) && !(n = n.call(a, u[1])).done) return n;
      switch (a = 0, n && (u = [u[0] & 2, n.value]), u[0]) {
        case 0:
        case 1:
          n = u;
          break;
        case 4:
          return r.label++, { value: u[1], done: !1 };
        case 5:
          r.label++, a = u[1], u = [0];
          continue;
        case 7:
          u = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (n = r.trys, !(n = n.length > 0 && n[n.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            r = 0;
            continue;
          }
          if (u[0] === 3 && (!n || u[1] > n[0] && u[1] < n[3])) {
            r.label = u[1];
            break;
          }
          if (u[0] === 6 && r.label < n[1]) {
            r.label = n[1], n = u;
            break;
          }
          if (n && r.label < n[2]) {
            r.label = n[2], r.ops.push(u);
            break;
          }
          n[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      u = t.call(e, r);
    } catch (f) {
      u = [6, f], a = 0;
    } finally {
      i = n = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, lr = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var i = r.call(e), a, n = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = i.next()).done; ) n.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (r = i.return) && r.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return n;
}, Tr = (
  /** @class */
  function() {
    function e(t, r) {
      var i = this, a;
      this._attributes = t, this.asyncAttributesPending = r != null, this._syncAttributes = (a = this._attributes) !== null && a !== void 0 ? a : {}, this._asyncAttributesPromise = r == null ? void 0 : r.then(function(n) {
        return i._attributes = Object.assign({}, i._attributes, n), i.asyncAttributesPending = !1, n;
      }, function(n) {
        return d.debug("a resource's async attributes promise rejected: %s", n), i.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[we] = cr(), t[w] = b[w], t[N] = b[N], t[C] = b[C], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && d.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return _r(this, void 0, void 0, function() {
        return Er(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var r = this, i;
      if (!t)
        return this;
      var a = T(T({}, this._syncAttributes), (i = t._syncAttributes) !== null && i !== void 0 ? i : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(a);
      var n = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(o) {
        var s, c = lr(o, 2), u = c[0], f = c[1];
        return T(T(T(T({}, r._syncAttributes), u), (s = t._syncAttributes) !== null && s !== void 0 ? s : t.attributes), f);
      });
      return new e(a, n);
    }, e.EMPTY = new e({}), e;
  }()
), Rn = (
  /** @class */
  function() {
    function e(t) {
      this._delegate = t;
    }
    return e.prototype.export = function(t, r) {
      this._delegate.export(t, r);
    }, e.prototype.forceFlush = function() {
      return this._delegate.forceFlush();
    }, e.prototype.shutdown = function() {
      return this._delegate.shutdown();
    }, e;
  }()
), dr = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, a) {
      i.__proto__ = a;
    } || function(i, a) {
      for (var n in a) Object.prototype.hasOwnProperty.call(a, n) && (i[n] = a[n]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function i() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (i.prototype = r.prototype, new i());
  };
}(), H = (
  /** @class */
  function(e) {
    dr(t, e);
    function t(r, i, a) {
      var n = e.call(this, r) || this;
      return n.name = "OTLPExporterError", n.data = a, n.code = i, n;
    }
    return t;
  }(Error)
);
function Or(e) {
  if (!Number.isNaN(e) && Number.isFinite(e) && e > 0)
    return e;
  throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + e + "')");
}
function Rr(e) {
  if (e != null)
    return function() {
      return e;
    };
}
function hr(e, t, r) {
  var i, a, n, o, s, c;
  return {
    timeoutMillis: Or((a = (i = e.timeoutMillis) !== null && i !== void 0 ? i : t.timeoutMillis) !== null && a !== void 0 ? a : r.timeoutMillis),
    concurrencyLimit: (o = (n = e.concurrencyLimit) !== null && n !== void 0 ? n : t.concurrencyLimit) !== null && o !== void 0 ? o : r.concurrencyLimit,
    compression: (c = (s = e.compression) !== null && s !== void 0 ? s : t.compression) !== null && c !== void 0 ? c : r.compression
  };
}
function pr() {
  return {
    timeoutMillis: 1e4,
    concurrencyLimit: 30,
    compression: "none"
  };
}
var yr = function(e, t, r, i) {
  function a(n) {
    return n instanceof r ? n : new r(function(o) {
      o(n);
    });
  }
  return new (r || (r = Promise))(function(n, o) {
    function s(f) {
      try {
        u(i.next(f));
      } catch (_) {
        o(_);
      }
    }
    function c(f) {
      try {
        u(i.throw(f));
      } catch (_) {
        o(_);
      }
    }
    function u(f) {
      f.done ? n(f.value) : a(f.value).then(s, c);
    }
    u((i = i.apply(e, t || [])).next());
  });
}, Lr = function(e, t) {
  var r = { label: 0, sent: function() {
    if (n[0] & 1) throw n[1];
    return n[1];
  }, trys: [], ops: [] }, i, a, n, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(u) {
    return function(f) {
      return c([u, f]);
    };
  }
  function c(u) {
    if (i) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (i = 1, a && (n = u[0] & 2 ? a.return : u[0] ? a.throw || ((n = a.return) && n.call(a), 0) : a.next) && !(n = n.call(a, u[1])).done) return n;
      switch (a = 0, n && (u = [u[0] & 2, n.value]), u[0]) {
        case 0:
        case 1:
          n = u;
          break;
        case 4:
          return r.label++, { value: u[1], done: !1 };
        case 5:
          r.label++, a = u[1], u = [0];
          continue;
        case 7:
          u = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (n = r.trys, !(n = n.length > 0 && n[n.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            r = 0;
            continue;
          }
          if (u[0] === 3 && (!n || u[1] > n[0] && u[1] < n[3])) {
            r.label = u[1];
            break;
          }
          if (u[0] === 6 && r.label < n[1]) {
            r.label = n[1], n = u;
            break;
          }
          if (n && r.label < n[2]) {
            r.label = n[2], r.ops.push(u);
            break;
          }
          n[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      u = t.call(e, r);
    } catch (f) {
      u = [6, f], a = 0;
    } finally {
      i = n = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, vr = (
  /** @class */
  function() {
    function e(t) {
      this._sendingPromises = [], this._concurrencyLimit = t;
    }
    return e.prototype.pushPromise = function(t) {
      var r = this;
      if (this.hasReachedLimit())
        throw new Error("Concurrency Limit reached");
      this._sendingPromises.push(t);
      var i = function() {
        var a = r._sendingPromises.indexOf(t);
        r._sendingPromises.splice(a, 1);
      };
      t.then(i, i);
    }, e.prototype.hasReachedLimit = function() {
      return this._sendingPromises.length >= this._concurrencyLimit;
    }, e.prototype.awaitAll = function() {
      return yr(this, void 0, void 0, function() {
        return Lr(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all(this._sendingPromises)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function Ar(e) {
  return new vr(e.concurrencyLimit);
}
function gr(e) {
  return Object.prototype.hasOwnProperty.call(e, "partialSuccess");
}
function Sr() {
  return {
    handleResponse: function(e) {
      e == null || !gr(e) || e.partialSuccess == null || Object.keys(e.partialSuccess).length === 0 || d.warn("Received Partial Success response:", JSON.stringify(e.partialSuccess));
    }
  };
}
var Ir = function(e, t, r, i) {
  function a(n) {
    return n instanceof r ? n : new r(function(o) {
      o(n);
    });
  }
  return new (r || (r = Promise))(function(n, o) {
    function s(f) {
      try {
        u(i.next(f));
      } catch (_) {
        o(_);
      }
    }
    function c(f) {
      try {
        u(i.throw(f));
      } catch (_) {
        o(_);
      }
    }
    function u(f) {
      f.done ? n(f.value) : a(f.value).then(s, c);
    }
    u((i = i.apply(e, t || [])).next());
  });
}, Pr = function(e, t) {
  var r = { label: 0, sent: function() {
    if (n[0] & 1) throw n[1];
    return n[1];
  }, trys: [], ops: [] }, i, a, n, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(u) {
    return function(f) {
      return c([u, f]);
    };
  }
  function c(u) {
    if (i) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (i = 1, a && (n = u[0] & 2 ? a.return : u[0] ? a.throw || ((n = a.return) && n.call(a), 0) : a.next) && !(n = n.call(a, u[1])).done) return n;
      switch (a = 0, n && (u = [u[0] & 2, n.value]), u[0]) {
        case 0:
        case 1:
          n = u;
          break;
        case 4:
          return r.label++, { value: u[1], done: !1 };
        case 5:
          r.label++, a = u[1], u = [0];
          continue;
        case 7:
          u = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (n = r.trys, !(n = n.length > 0 && n[n.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            r = 0;
            continue;
          }
          if (u[0] === 3 && (!n || u[1] > n[0] && u[1] < n[3])) {
            r.label = u[1];
            break;
          }
          if (u[0] === 6 && r.label < n[1]) {
            r.label = n[1], n = u;
            break;
          }
          if (n && r.label < n[2]) {
            r.label = n[2], r.ops.push(u);
            break;
          }
          n[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      u = t.call(e, r);
    } catch (f) {
      u = [6, f], a = 0;
    } finally {
      i = n = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, br = (
  /** @class */
  function() {
    function e(t, r, i, a, n) {
      this._transport = t, this._serializer = r, this._responseHandler = i, this._promiseQueue = a, this._timeout = n, this._diagLogger = d.createComponentLogger({
        namespace: "OTLPExportDelegate"
      });
    }
    return e.prototype.export = function(t, r) {
      var i = this;
      if (this._diagLogger.debug("items to be sent", t), this._promiseQueue.hasReachedLimit()) {
        r({
          code: l.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      var a = this._serializer.serializeRequest(t);
      if (a == null) {
        r({
          code: l.FAILED,
          error: new Error("Nothing to send")
        });
        return;
      }
      this._promiseQueue.pushPromise(this._transport.send(a, this._timeout).then(function(n) {
        if (n.status === "success") {
          if (n.data != null)
            try {
              i._responseHandler.handleResponse(i._serializer.deserializeResponse(n.data));
            } catch (o) {
              i._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", o, n.data);
            }
          r({
            code: l.SUCCESS
          });
          return;
        } else if (n.status === "failure" && n.error) {
          r({
            code: l.FAILED,
            error: n.error
          });
          return;
        } else n.status === "retryable" ? r({
          code: l.FAILED,
          error: new H("Export failed with retryable status")
        }) : r({
          code: l.FAILED,
          error: new H("Export failed with unknown error")
        });
      }, function(n) {
        return r({
          code: l.FAILED,
          error: n
        });
      }));
    }, e.prototype.forceFlush = function() {
      return this._promiseQueue.awaitAll();
    }, e.prototype.shutdown = function() {
      return Ir(this, void 0, void 0, function() {
        return Pr(this, function(t) {
          switch (t.label) {
            case 0:
              return this._diagLogger.debug("shutdown started"), [4, this.forceFlush()];
            case 1:
              return t.sent(), this._transport.shutdown(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function mr(e, t) {
  return new br(e.transport, e.serializer, Sr(), e.promiseHandler, t.timeout);
}
function q(e, t, r) {
  return mr({
    transport: r,
    serializer: t,
    promiseHandler: Ar(e)
  }, { timeout: e.timeoutMillis });
}
function z(e) {
  var t = BigInt(1e9);
  return BigInt(e[0]) * t + BigInt(e[1]);
}
function Nr(e) {
  var t = Number(BigInt.asUintN(32, e)), r = Number(BigInt.asUintN(32, e >> BigInt(32)));
  return { low: t, high: r };
}
function Z(e) {
  var t = z(e);
  return Nr(t);
}
function wr(e) {
  var t = z(e);
  return t.toString();
}
var Cr = typeof BigInt < "u" ? wr : or;
function V(e) {
  return e;
}
function ee(e) {
  if (e !== void 0)
    return B(e);
}
var Mr = {
  encodeHrTime: Z,
  encodeSpanContext: B,
  encodeOptionalSpanContext: ee
};
function hn(e) {
  var t, r;
  if (e === void 0)
    return Mr;
  var i = (t = e.useLongBits) !== null && t !== void 0 ? t : !0, a = (r = e.useHex) !== null && r !== void 0 ? r : !1;
  return {
    encodeHrTime: i ? Z : Cr,
    encodeSpanContext: a ? V : B,
    encodeOptionalSpanContext: a ? V : ee
  };
}
var Ur = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var i = r.call(e), a, n = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = i.next()).done; ) n.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (r = i.return) && r.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return n;
};
function pn(e) {
  return {
    attributes: Br(e.attributes),
    droppedAttributesCount: 0
  };
}
function yn(e) {
  return {
    name: e.name,
    version: e.version
  };
}
function Br(e) {
  return Object.keys(e).map(function(t) {
    return re(t, e[t]);
  });
}
function re(e, t) {
  return {
    key: e,
    value: ne(t)
  };
}
function ne(e) {
  var t = typeof e;
  return t === "string" ? { stringValue: e } : t === "number" ? Number.isInteger(e) ? { intValue: e } : { doubleValue: e } : t === "boolean" ? { boolValue: e } : e instanceof Uint8Array ? { bytesValue: e } : Array.isArray(e) ? { arrayValue: { values: e.map(ne) } } : t === "object" && e != null ? {
    kvlistValue: {
      values: Object.entries(e).map(function(r) {
        var i = Ur(r, 2), a = i[0], n = i[1];
        return re(a, n);
      })
    }
  } : {};
}
var xr = function(e, t, r, i) {
  function a(n) {
    return n instanceof r ? n : new r(function(o) {
      o(n);
    });
  }
  return new (r || (r = Promise))(function(n, o) {
    function s(f) {
      try {
        u(i.next(f));
      } catch (_) {
        o(_);
      }
    }
    function c(f) {
      try {
        u(i.throw(f));
      } catch (_) {
        o(_);
      }
    }
    function u(f) {
      f.done ? n(f.value) : a(f.value).then(s, c);
    }
    u((i = i.apply(e, t || [])).next());
  });
}, Dr = function(e, t) {
  var r = { label: 0, sent: function() {
    if (n[0] & 1) throw n[1];
    return n[1];
  }, trys: [], ops: [] }, i, a, n, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(u) {
    return function(f) {
      return c([u, f]);
    };
  }
  function c(u) {
    if (i) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (i = 1, a && (n = u[0] & 2 ? a.return : u[0] ? a.throw || ((n = a.return) && n.call(a), 0) : a.next) && !(n = n.call(a, u[1])).done) return n;
      switch (a = 0, n && (u = [u[0] & 2, n.value]), u[0]) {
        case 0:
        case 1:
          n = u;
          break;
        case 4:
          return r.label++, { value: u[1], done: !1 };
        case 5:
          r.label++, a = u[1], u = [0];
          continue;
        case 7:
          u = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (n = r.trys, !(n = n.length > 0 && n[n.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            r = 0;
            continue;
          }
          if (u[0] === 3 && (!n || u[1] > n[0] && u[1] < n[3])) {
            r.label = u[1];
            break;
          }
          if (u[0] === 6 && r.label < n[1]) {
            r.label = n[1], n = u;
            break;
          }
          if (n && r.label < n[2]) {
            r.label = n[2], r.ops.push(u);
            break;
          }
          n[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      u = t.call(e, r);
    } catch (f) {
      u = [6, f], a = 0;
    } finally {
      i = n = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, Xr = 5, Gr = 1e3, Hr = 5e3, Vr = 1.5, F = 0.2;
function Fr() {
  return Math.random() * (2 * F) - F;
}
var jr = (
  /** @class */
  function() {
    function e(t) {
      this._transport = t;
    }
    return e.prototype.retry = function(t, r, i) {
      var a = this;
      return new Promise(function(n, o) {
        setTimeout(function() {
          a._transport.send(t, r).then(n, o);
        }, i);
      });
    }, e.prototype.send = function(t, r) {
      var i;
      return xr(this, void 0, void 0, function() {
        var a, n, o, s, c, u, f;
        return Dr(this, function(_) {
          switch (_.label) {
            case 0:
              return a = Date.now() + r, [4, this._transport.send(t, r)];
            case 1:
              n = _.sent(), o = Xr, s = Gr, _.label = 2;
            case 2:
              return n.status === "retryable" && o > 0 ? (o--, c = Math.max(Math.min(s, Hr) + Fr(), 0), s = s * Vr, u = (i = n.retryInMillis) !== null && i !== void 0 ? i : c, f = a - Date.now(), u > f ? [2, n] : [4, this.retry(t, f, u)]) : [3, 4];
            case 3:
              return n = _.sent(), [3, 2];
            case 4:
              return [2, n];
          }
        });
      });
    }, e.prototype.shutdown = function() {
      return this._transport.shutdown();
    }, e;
  }()
);
function te(e) {
  return new jr(e.transport);
}
function Kr(e) {
  var t = [429, 502, 503, 504];
  return t.includes(e);
}
function Yr(e) {
  if (e != null) {
    var t = Number.parseInt(e, 10);
    if (Number.isInteger(t))
      return t > 0 ? t * 1e3 : -1;
    var r = new Date(e).getTime() - Date.now();
    return r >= 0 ? r : 0;
  }
}
var $r = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var i = r.call(e), a, n = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = i.next()).done; ) n.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (r = i.return) && r.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return n;
}, kr = (
  /** @class */
  function() {
    function e(t) {
      this._parameters = t;
    }
    return e.prototype.send = function(t, r) {
      var i = this;
      return new Promise(function(a) {
        var n = new XMLHttpRequest();
        n.timeout = r, n.open("POST", i._parameters.url);
        var o = i._parameters.headers();
        Object.entries(o).forEach(function(s) {
          var c = $r(s, 2), u = c[0], f = c[1];
          n.setRequestHeader(u, f);
        }), n.ontimeout = function(s) {
          a({
            status: "failure",
            error: new Error("XHR request timed out")
          });
        }, n.onreadystatechange = function() {
          n.status >= 200 && n.status <= 299 ? (d.debug("XHR success"), a({
            status: "success"
          })) : n.status && Kr(n.status) ? a({
            status: "retryable",
            retryInMillis: Yr(n.getResponseHeader("Retry-After"))
          }) : n.status !== 0 && a({
            status: "failure",
            error: new Error("XHR request failed with non-retryable status")
          });
        }, n.onabort = function() {
          a({
            status: "failure",
            error: new Error("XHR request aborted")
          });
        }, n.onerror = function() {
          a({
            status: "failure",
            error: new Error("XHR request errored")
          });
        }, n.send(t);
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function Jr(e) {
  return new kr(e);
}
var Qr = (
  /** @class */
  function() {
    function e(t) {
      this._params = t;
    }
    return e.prototype.send = function(t) {
      var r = this;
      return new Promise(function(i) {
        navigator.sendBeacon(r._params.url, new Blob([t], { type: r._params.blobType })) ? (d.debug("SendBeacon success"), i({
          status: "success"
        })) : i({
          status: "failure",
          error: new Error("SendBeacon failed")
        });
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function Wr(e) {
  return new Qr(e);
}
function qr(e, t) {
  return q(e, t, te({
    transport: Jr(e)
  }));
}
function zr(e, t) {
  return q(e, t, te({
    transport: Wr({
      url: e.url,
      blobType: e.headers()["Content-Type"]
    })
  }));
}
var Zr = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var i = r.call(e), a, n = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = i.next()).done; ) n.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (r = i.return) && r.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return n;
};
function en(e) {
  return function() {
    var t, r = {};
    return Object.entries((t = e == null ? void 0 : e()) !== null && t !== void 0 ? t : {}).forEach(function(i) {
      var a = Zr(i, 2), n = a[0], o = a[1];
      typeof o < "u" ? r[n] = String(o) : d.warn('Header "' + n + '" has invalid value (' + o + ") and will be ignored");
    }), r;
  };
}
var R = function() {
  return R = Object.assign || function(e) {
    for (var t, r = 1, i = arguments.length; r < i; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, R.apply(this, arguments);
};
function rn(e, t, r) {
  var i = R({}, r()), a = {};
  return function() {
    return t != null && Object.assign(a, t()), e != null && Object.assign(a, e()), Object.assign(a, i);
  };
}
function nn(e) {
  if (e != null)
    try {
      return new URL(e), e;
    } catch {
      throw new Error("Configuration: Could not parse user-provided export URL: '" + e + "'");
    }
}
function tn(e, t, r) {
  var i, a, n, o;
  return R(R({}, hr(e, t, r)), { headers: rn(en(e.headers), t.headers, r.headers), url: (a = (i = nn(e.url)) !== null && i !== void 0 ? i : t.url) !== null && a !== void 0 ? a : r.url, agentOptions: (o = (n = e.agentOptions) !== null && n !== void 0 ? n : t.agentOptions) !== null && o !== void 0 ? o : r.agentOptions });
}
function an(e, t) {
  return R(R({}, pr()), { headers: function() {
    return e;
  }, url: "http://localhost:4318/" + t, agentOptions: { keepAlive: !0 } });
}
function un(e, t, r) {
  return tn(
    {
      url: e.url,
      timeoutMillis: e.timeoutMillis,
      headers: Rr(e.headers),
      concurrencyLimit: e.concurrencyLimit
    },
    {},
    // no fallback for browser case
    an(r, t)
  );
}
function Ln(e, t, r, i) {
  var a = !!e.headers || typeof navigator.sendBeacon != "function", n = un(e, r, i);
  return a ? qr(n, t) : zr(n, t);
}
function vn({ serviceName: e, version: t, host: r, environment: i }) {
  const a = {};
  return e && (a[Be] = e, a[Ue] = r ?? (window == null ? void 0 : window.location.host), a["host.name"] = r ?? (window == null ? void 0 : window.location.host)), i && (a["deployment.environment.name"] = i), t && (a[xe] = t), new Tr(a);
}
export {
  ln as A,
  ur as B,
  ge as C,
  m as D,
  l as E,
  g as F,
  W as G,
  sr as H,
  De as I,
  Tn as J,
  Re as K,
  or as L,
  Rn as O,
  Tr as R,
  M as T,
  J as _,
  X as a,
  fn as b,
  de as c,
  d,
  cn as e,
  I as f,
  v as g,
  P as h,
  sn as i,
  On as j,
  _n as k,
  pn as l,
  yn as m,
  ne as n,
  re as o,
  hn as p,
  Ln as q,
  j as r,
  vn as s,
  En as t,
  K as u,
  on as v,
  Br as w,
  U as x,
  Q as y,
  dn as z
};
